import React, { lazy,Fragment, useContext as UseContext} from 'react';
import { useHistory, Link } from "react-router-dom";
import usuariosService from "../../services/usuarios.service";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Avatar,
  Box,
  Badge,
  Menu,
  Button,
  List,
  ListItem,
  Tooltip,
  Divider
} from '@material-ui/core';

import avatar4 from '../../assets/images/avatars/avatar4.jpg';
import { withStyles } from '@material-ui/core/styles';
import { deepOrange, deepPurple } from '@mui/material/colors';

import { AuthContext } from "../../components/Authentication/AuthComponent";

const StyledBadge = withStyles({
  badge: {
    backgroundColor: 'var(--success)',
    color: 'var(--success)',
    boxShadow: '0 0 0 2px #fff',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""'
    }
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0
    }
  }
})(Badge);
export default function HeaderUserbox() {
  const context = UseContext(AuthContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();
  const CambiarClave = lazy(()=> import('../../pages/Usuario/CambiarClave'));

  const resetPassword = () =>{
    history.push("/CambiarClave");
  }
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

 
  const handleLogOut = () => {
    usuariosService.Salir().then(sale => {     
        context.doLogout();        
    });
    history.push("/Login");
  };
  
  const alumno = JSON.parse(sessionStorage.getItem("alumno"));

  return (
    <Fragment>
      <Button
        color="inherit"
        onClick={handleClick}
        className="text-capitalize px-3 text-left btn-inverse d-flex align-items-center">
        <Box>
          <StyledBadge
            overlap="circular"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            variant="dot">
           <Avatar sx={{ bgcolor: deepOrange[500] }}>{alumno.nombres[0] + alumno.apellido[0]}</Avatar>
          </StyledBadge>
        </Box>
        <div className="d-none d-xl-block pl-3">
          <div className="font-weight-bold pt-2 line-height-1">
          {alumno.nombres + " " +  alumno.apellido}
          </div>
          <span className="text-white-50">{alumno.email}</span>
        </div>        
      </Button>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        onClose={handleClose}
        className="ml-2">
        <div className="dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
          <List className="text-left bg-transparent d-flex align-items-center flex-column pt-0">
            <Box>
              <StyledBadge
                overlap="circular"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                variant="dot">
                <Avatar sx={{ bgcolor: deepOrange[500] }}>{alumno.nombres[0] + alumno.apellido[0]}</Avatar>
              </StyledBadge>
            </Box>
            <div className="pl-3 ">
              <div className="font-weight-bold text-center pt-2 line-height-1">
              {alumno.nombres + " " +  alumno.apellido}
              </div>
              <span className="text-black-50 text-center">
              {alumno.email}
              </span>
            </div>           
            <Divider className="w-100 mt-2" />
            <List component="nav">
              <ListItem button onClick={resetPassword}>Cambiar contraseña</ListItem>
            </List>
            <Divider className="w-100 mt-2" />
            <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
              <Tooltip arrow title="Salir">
                <Button     
                  color="default" 
                  onClick={handleLogOut}
                >
                  <span className="btn-wrapper--icon">
                  <FontAwesomeIcon icon="fas-solid fas-right-from-bracket" />
                  Salir
                  </span>
                </Button>
              </Tooltip>
              
            </ListItem>
          </List>          
        </div>
      </Menu>
    </Fragment>
  );
}
